import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { SAVE_200_MSG } from 'constants/index'
import { getWorkOrdersForInvoice2 } from 'services/workOrder'
import { deleteWorkOrdersFromInvoice } from 'services/invoice2workOrder'
import actions from './actions'

function* fetchExistingWorkOrderFilterForInvoice2({ size, index, searchTerm, orderBy, invoiceID }) {
  size = size || localStorage.getItem('pageSize') || 150

  const savedFilters = localStorage.getItem('invoiceExistingWorkOrderFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)
    invoiceID = invoiceID || parsedFilters.invoiceID || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    getWorkOrdersForInvoice2,
    size,
    index,
    searchTerm,
    orderBy,
    null,
    null,
    null,
    null,
    invoiceID,
    null, // Invoiced
  )
  yield put({
    type: actions.LIST_WORKORDER_FOR_EXISTING_INVOICE2,
    result,
  })
}

function* fetchDeleteWorkOrdersFromInvoice(values) {
  console.log('fetchDeleteWorkOrdersFromInvoice', values)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(deleteWorkOrdersFromInvoice, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
      yield put({
        type: actions.DELETE_WORKORDERS_FROM_INVOICE2_RECIEVED,
        result,
      })
    } else {
      notification.error({ message: 'Error', description: result.message })
      yield put({
        type: actions.RESPONSE_ERROR,
        message: result.message,
      })
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.FETCH_WORKORDERS_FILTER_FOR_EXISTING_INVOICE2,
      fetchExistingWorkOrderFilterForInvoice2,
    ),
    takeEvery(actions.DELETE_WORKORDERS_FROM_INVOICE2, fetchDeleteWorkOrdersFromInvoice),
  ])
}
